import { Outlet } from "react-router";

const LoginLayout = () => {
  return <Outlet />;
};

export default LoginLayout;
